import React, { useState, useContext } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Chapa from "../components/Chapa";
import { useLocation } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

const Payment = () => {
  const { t } = useContext(LanguageContext);
  const location = useLocation();
  const { price, items, orderId, shippingInfo } = location.state || {};
  const [paymentMethod, setPaymentMethod] = useState("chapa");

  return (
    <div>
      <Headers />
      <section className="bg-[#eeeeee]">
        <div className="max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10 py-16 mt-4">
          <div className="flex flex-wrap md:flex-col-reverse">
            <div className="w-7/12 md:w-full">
              <div className="pr-2 md:pr-0">
                <div className="flex flex-wrap">
                  <div
                    onClick={() => setPaymentMethod("chapa")}
                    className={`w-[20%] border-r cursor-pointer py-8 px-12 ${
                      paymentMethod === "chapa" ? "bg-white" : "bg-slate-100"
                    }`}
                  >
                    <div className="flex flex-col gap-[3px] justify-center items-center">
                      <img src="/images/payment/chapa.jpg" alt="chapa" />
                      <span className="text-slate-600">Chapa</span>
                    </div>
                  </div>
                </div>

                {paymentMethod === "chapa" && (
                  <div>
                    <Chapa
                      orderId={orderId}
                      price={price}
                      shippingInfo={shippingInfo}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="w-5/12 md:w-full">
              <div className="pl-2 md:pl-0 md:mb-0">
                <div className="bg-white shadow p-5 text-slate-600 flex flex-col gap-3">
                  <h2>{t("orderSummary")}</h2>
                  <div className="flex justify-between items-center">
                    <span>
                      {(
                        t("itemsAndShippingIncluded") ||
                        "{items} items and shipping fee included"
                      ).replace("{items}", items || 0)}
                    </span>
                    <span>
                      {price} {t("currency")}
                    </span>
                  </div>
                  <div className="flex justify-between items-center font-semibold">
                    <span>{t("totalAmount")}</span>
                    <span className="text-lg text-orange-500">
                      {price} {t("currency")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Payment;
